import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import GlassCard from '@/components/base/GlassCard';
import KpiCard from '@/components/base/KpiCard';
import { performanceScatterData, algorithmExplanation } from '@/mocks/dashboardData';

const PerformancePage: React.FC = () => (
  <div>
    <div className="mb-5">
      <h1 className="text-xl font-bold text-white" style={{ fontFamily: 'Inter, sans-serif' }}>Performans & Algoritma</h1>
      <p className="text-xs mt-0.5" style={{ color: '#6b7280' }}>Sistem mantığı ve puan-gelir ilişkisi</p>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
      <KpiCard label="Ort. Puan" value="4.3" change={0.8} icon="ri-star-line" suffix="/5" />
      <KpiCard label="Toplam İş" value={2840} change={15.2} icon="ri-briefcase-4-line" />
      <KpiCard label="Görünürlük Artışı" value={68} change={12.4} icon="ri-eye-line" suffix="%" />
      <KpiCard label="Büyüme Oranı" value={22} change={5.1} icon="ri-rocket-line" suffix="%" />
    </div>

    {/* Algorithm cards */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
      {algorithmExplanation.map((item) => (
        <div key={item.baslik} className="rounded-xl p-4 transition-all duration-300 hover:-translate-y-1" style={{ background: 'rgba(255,255,255,0.03)', border: `1px solid ${item.renk}33` }}>
          <div className="w-9 h-9 rounded-xl flex items-center justify-center mb-3" style={{ background: `${item.renk}22` }}>
            <i className={`${item.icon} text-base`} style={{ color: item.renk }}></i>
          </div>
          <h3 className="text-sm font-semibold text-white mb-1.5 leading-snug">{item.baslik}</h3>
          <p className="text-xs leading-relaxed" style={{ color: '#6b7280' }}>{item.aciklama}</p>
        </div>
      ))}
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <GlassCard title="Puan vs Kazanç" subtitle="Her nokta bir uzmanı temsil eder">
        <ResponsiveContainer width="100%" height={240}>
          <ScatterChart>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
            <XAxis dataKey="puan" name="Puan" type="number" domain={[3, 5]} tick={{ fill: '#6b7280', fontSize: 11 }} axisLine={false} tickLine={false} label={{ value: 'Puan', position: 'insideBottom', offset: -5, fill: '#6b7280', fontSize: 11 }} />
            <YAxis dataKey="kazanc" name="Kazanç" tick={{ fill: '#6b7280', fontSize: 11 }} axisLine={false} tickLine={false} tickFormatter={(v) => `${(v / 1000).toFixed(0)}k`} />
            <Tooltip
              contentStyle={{ background: '#1a1a2e', border: '1px solid rgba(255,77,77,0.3)', borderRadius: '8px', fontSize: '12px' }}
              formatter={(v: number, name: string) => [name === 'kazanc' ? `${v.toLocaleString('tr-TR')} ₺` : v, name === 'kazanc' ? 'Kazanç' : 'Puan']}
            />
            <Scatter data={performanceScatterData} fill="#ff6b47" opacity={0.85} />
          </ScatterChart>
        </ResponsiveContainer>
      </GlassCard>

      <GlassCard title="Puan vs İş Sayısı" subtitle="Yüksek puan daha fazla iş demek">
        <ResponsiveContainer width="100%" height={240}>
          <ScatterChart>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
            <XAxis dataKey="puan" name="Puan" type="number" domain={[3, 5]} tick={{ fill: '#6b7280', fontSize: 11 }} axisLine={false} tickLine={false} label={{ value: 'Puan', position: 'insideBottom', offset: -5, fill: '#6b7280', fontSize: 11 }} />
            <YAxis dataKey="is" name="İş Sayısı" tick={{ fill: '#6b7280', fontSize: 11 }} axisLine={false} tickLine={false} />
            <Tooltip
              contentStyle={{ background: '#1a1a2e', border: '1px solid rgba(255,77,77,0.3)', borderRadius: '8px', fontSize: '12px' }}
              formatter={(v: number, name: string) => [v, name === 'is' ? 'İş Sayısı' : 'Puan']}
            />
            <Scatter data={performanceScatterData} fill="#ff8c42" opacity={0.85} />
          </ScatterChart>
        </ResponsiveContainer>
      </GlassCard>
    </div>
  </div>
);

export default PerformancePage;
